import { Column } from 'app/design/primitives/box';
import { Text } from 'app/design/primitives/text';
import React from 'react';

export function CountBadge({ count }: { count: number }) {
  return (
    <Column
      alignItems="center"
      backgroundColor={count > 0 ? 'text.error' : 'surface.secondary-neutral'}
      borderRadius="radius.full"
      justifyContent="center"
      marginLeft="spacing.general.x1"
      minHeight={24}
      minWidth={24}
      paddingHorizontal="spacing.general.x1"
      style={{ marginRight: 'auto' }}
    >
      <Text color="surface.default" fontSize={12} fontWeight="700">
        {count}
      </Text>
    </Column>
  );
}
